import React from 'react';
import { Div, DivProps, Image, ImageProps, P } from '@kizi/core-components';

export interface AvatarProps extends DivProps {
  imageProps?: ImageProps;
  name: string;
  role: string;
  url: string;
}

export const Avatar: React.FC<AvatarProps> = React.forwardRef<
  HTMLDivElement,
  AvatarProps
>(({ imageProps, name, role, url, ...divProps }, ref) => {
  return (
    <Div
      alignItems="center"
      display="flex"
      flexDirection="column"
      ref={ref}
      variant="avatar"
      {...divProps}
    >
      <Image alt="" src={url} {...imageProps} />
      <Div
        alignItems="center"
        display={['none', null, 'flex']}
        flexDirection="column"
        justifyContent="center"
      >
        <P textAlign="center" variant="headlineImportant">
          {name}
        </P>
        <P variant="footnoteRegular">{role}</P>
      </Div>
    </Div>
  );
});
